// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React, { ChangeEvent, FC, useRef } from 'react';

import { BaseProps } from '../Base';
import { HiddenCheckbox, StyledCheckbox, StyledCheckmark } from './Styled';
import Check from '../../icons/Check';

export interface CheckboxProps
  extends Omit<
      React.InputHTMLAttributes<HTMLInputElement>,
      'onChange' | 'value' | 'size'
    >,
    BaseProps {
  /** The callback fired when the state is changed. */
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  /** The value of the checkbox. */
  value: string;
  /** Whether or not the checkbox is checked. */
  checked?: boolean;
  /** チェックボックスのサイズを定義する。デフォルトは`md`。 */
  size?: CheckboxSize;
}

export type CheckboxSize = 'md' | 'lg';

export const Checkbox: FC<CheckboxProps> = (props: CheckboxProps) => {
  const { checked, onChange, value, size, ...rest } = props;
  return (
    <StyledCheckbox size={size}>
      <HiddenCheckbox
        {...rest}
        data-testid="hidden-checkbox"
        type="checkbox"
        value={value}
        checked={checked}
        onChange={onChange}
      />
      <StyledCheckmark data-testid="styled-checkbox" size={size}>
        {checked && <Check data-testid="check" width="100%" height="100%" />}
      </StyledCheckmark>
    </StyledCheckbox>
  );
};
Checkbox.displayName = 'Checkbox';

export default Checkbox;
